/**
 * Basic Present Value Formula (Lump Sum Model)
 * "If I will receive a single amount of money in the future, how much is it worth today?"
 */
export function calculatePV(futureValue, inflationRate, periods) {
  const pv = futureValue / Math.pow(1 + inflationRate, periods);
  return pv;
}

/**
 * Basic Present Value Formula (Recurring Payment Model)
 * "If I receive the same amount of money every period (month/year/etc), how much is that worth today?"
 *
 * Type: 0 - Indicates payment at the end of the period
 * Type: 1 - Indicates payment at the beginning of the period
 *           Each early payment is discounted for fewer periods, so it's worth more.
 */
export function pvAnnuity(payment, inflationRate, periods, type = 0) {
  //return (payment * (1 - Math.pow(1 + rate, -periods))) / rate;
  const pv = (payment * (1 - Math.pow(1 + inflationRate, -periods))) / inflationRate;
  return type === 1 ? pv * (1 + inflationRate) : pv;
}

/**
 * Determine how much monthly income you'll need in X number of years
 * to have the same purchasing power today, assuming Y% inflation annually.
 *
 * presentValue - Monthly income in today's value
 * annualInflationRate - Assumed inflation rate
 * years - Over the next X number of years
 */
export function calculateInflatedFutureValue(presentValue, annualInflationRate, years) {
  const futureValue = presentValue * Math.pow(1 + annualInflationRate / 100, years);
  return futureValue;
}
